import { INTERNAL_PLUGINS } from '@ember/template-compiler/-internal-primitives';

export default INTERNAL_PLUGINS.TransformQuotedBindingsIntoJustBindings;
